var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5",class:{
    ' bg-green-100 text-green-800': _vm.isEnabled,
    'bg-red-100 text-red-800': _vm.isDisabled,
    'bg-yellow-100 text-yellow-800': _vm.isExpiring,
    'bg-red-100 text-red-800': _vm.isExpired,
  }},[_vm._v(" "+_vm._s(_vm._f("name")(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }